import {Box, Icon} from "@mui/material";
import {alpha} from "@mui/material/styles";

export default function IconBadge({
    children,
    color = "primary",
    size = 44,
    sx
}) {
    return (
        <Box
            component="span"
            sx={[
                (theme) => {
                    const tone = color.split(".")[0];
                    const foreground =
                        theme.palette.icon?.[tone] ||
                        theme.palette[tone]?.main ||
                        theme.palette.text.secondary;
                    const dark = theme.palette.mode === "dark";
                    return {
                        width: size,
                        height: size,
                        flexShrink: 0,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 2,
                        color: foreground,
                        bgcolor:
                            theme.palette.iconBackground?.[tone] ||
                            alpha(foreground, dark ? 0.14 : 0.09),
                        border: `1px solid ${alpha(
                            foreground,
                            dark ? 0.55 : 0.22
                        )}`,
                        "& .MuiIcon-root": {fontSize: size <= 36 ? 22 : 26}
                    };
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        >
            <Icon>{children}</Icon>
        </Box>
    );
}
